import React from 'react'
import mount from '../lib/mount'
import App from '../components/App'
import TopicFollowButton from '../components/TopicFollowButton'
import TopicFollowersCount from '../components/TopicFollowersCount'

document.addEventListener('turbolinks:load', () => {
  document.querySelectorAll("[id^='react-topic-follow-button-']").forEach((match) => {
    const data = JSON.parse(match.getAttribute('data'))
    mount(
      match,
      <App>
        <TopicFollowButton
          slug={data.slug}
          href={data.href}
          followersCount={data.followersCount} />
      </App>,
    )
  })

  document.querySelectorAll("[id^='react-topic-followers-count-']").forEach((match) => {
    const data = JSON.parse(match.getAttribute('data'))
    mount(
      match,
      <App>
        <TopicFollowersCount
          slug={data.slug}
          followersCount={data.followersCount}
          format={data.format} />
      </App>,
    )
  })
})
